<template>
  <v-container
    fluid
  >
    <v-row>
      <v-col
        cols="4"
      >
        <v-text-field
          v-model="new_contact.display_name"
          label="Name"
          outlined
          dense
          clearable
          hide-details
          @keydown.enter="set_entry('-1', new_contact.display_name, new_contact.phonenumber);  new_contact = {display_name: null, phonenumber: null}"
        ></v-text-field>
      </v-col>
      <v-col
        cols="4"
      >
        <v-text-field
          v-model="new_contact.phonenumber"
          label="Telefonnummer"
          outlined
          dense
          clearable
          hide-details
          @keydown.enter="set_entry('-1', new_contact.display_name, new_contact.phonenumber); new_contact = {display_name: null, phonenumber: null}"
        ></v-text-field>
      </v-col>
      <v-col
        cols="4"
      >
        <v-btn
          class="primary"
          :disabled="!new_contact_is_valid"
          @click="set_entry('-1', new_contact.display_name, new_contact.phonenumber); new_contact = {display_name: null, phonenumber: null}"
          small
        >
          Hinzufügen
        </v-btn>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              outlined
              small
              class="ma-1"
              v-bind="attrs"
              v-on="on"
              @click="download_lardis"
            >
              Lardis
              <v-icon
                small
              >
                mdi-download
              </v-icon>
            </v-btn>
          </template>
          <span>
            1. WSRTH09 über VNC starten und Anmelden <br>
            2. Lardis-Manager öffnen<br>
            3. Konfigurieren -> Telefonbuch -> Telefon<br>
            4. CSV über den Knopf "Import" unten rechts importieren<br>
            5. Speichern<br>
          </span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              outlined
              small
              class="ma-1"
              v-bind="attrs"
              v-on="on"
              @click="download_easybell"
            >
              easybell
              <v-icon
                small
              >
                mdi-download
              </v-icon>
            </v-btn>
          </template>
          <span>
            1. https://login.easybell.de öffnen <br>
            2. Telefonfunktionen -> Kontakte<br>
            3. Alle Kontakte markieren und löschen<br>
            4. CSV importieren<br>
            <br>
            Der Vorgang dauert ca. 30s Sekunden! <br>
            Kontakte werden erst nach einem Neuladen der Seite angezeigt.
          </span>
        </v-tooltip>
      </v-col>
      <v-col
        cols="12"
        class="pt-0"
      >
        <!---
        <v-text-field
          v-model="search"
          label="Suche"
          append-icon="mdi-magnify"
          outlined
          dense
          hide-details
        ></v-text-field> --->
        <v-card-subtitle
          class="ma-0 pa-0"
        >
          Zuletzt aktualisiert: {{ $store.state.phonebook.last_updated }}
        </v-card-subtitle>
        <v-data-table
          :headers="headers"
          :items="phonebook"
          :loading="$store.state.phonebook.book === null"
          :items-per-page="-1"
          hide-default-footer
          dense
          :search="$store.state.general.global_search"
        >
          <template v-slot:item.call="{ item }">
            <v-btn
              icon
              @click="call_entry(item)"
            >
              <v-icon
                color="success"
              >
                mdi-phone
              </v-icon>
            </v-btn>
          </template>

          <template v-slot:item.displayName="{ item }">
            <div
              v-if="display_name_edit.includes(item.id)"
            >
              <v-text-field
                dense
                v-model="item.displayName"
                append-icon="mdi-check"
                append-outer-icon="mdi-close"
                hide-details
                maxlength="90"
                style="max-width: 250px"
                @click:append="set_entry(item.id, item.displayName, item.phonenumber + ''); display_name_edit.splice(display_name_edit.indexOf(item.id), 1)"
                @keydown.enter="set_entry(item.id, item.displayName, item.phonenumber + ''); display_name_edit.splice(display_name_edit.indexOf(item.id), 1)"
                @click:append-outer="display_name_edit.splice(display_name_edit.indexOf(item.id))"
              >
              </v-text-field>
            </div>
            <div
              v-else
            >
              {{ item.displayName }}
              <v-btn
                icon
                small
                @click="display_name_edit.push(item.id)"
              >
                <v-icon
                  small
                >
                  mdi-pencil
                </v-icon>
              </v-btn>
            </div>
          </template>

          <template v-slot:item.phonenumber="{ item }">
            <div
              v-if="phonenumber_edit.includes(item.id)"
            >
              <v-text-field
                dense
                v-model="item.phonenumber"
                append-icon="mdi-check"
                append-outer-icon="mdi-close"
                maxlength="15"
                hide-details
                style="max-width: 250px"
                @click:append="set_entry(item.id, item.displayName, item.phonenumber + ''); phonenumber_edit.splice(phonenumber_edit.indexOf(item.id), 1)"
                @keydown.enter="set_entry(item.id, item.displayName, item.phonenumber + ''); phonenumber_edit.splice(phonenumber_edit.indexOf(item.id), 1)"
                @click:append-outer="phonenumber_edit.splice(display_name_edit.indexOf(item.id))"
              >
              </v-text-field>
            </div>
            <div
              v-else
            >
              {{ item.phonenumber }}
              <v-btn
                icon
                small
                @click="phonenumber_edit.push(item.id)"
              >
                <v-icon
                  small
                >
                  mdi-pencil
                </v-icon>
              </v-btn>
            </div>
          </template>

          <template v-slot:item.delete="{ item }">
            <v-btn
              icon
              @click="delete_entry(item)"
            >
              <v-icon
                color="error"
              >
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "pb-manage",
  data: () => ({
    search: null,
    new_contact: {
      displayName: null,
      phonenumber: null
    },
    display_name_edit: [],
    phonenumber_edit: [],
    headers: [
      { text: 'Anrufen', value: 'call', sortable: false },
      { text: 'Name', value: 'displayName', sortable: false },
      { text: 'Nummer', value: 'phonenumber', sortable: false },
      //{ text: 'Scope', value: 'scope', sortable: false },
      { text: 'Löschen', value: 'delete', sortable: false },
    ]
  }),
  methods: {
    download_lardis() {
      let string = "\uFEFF"; // UTF-8 BOM hinzufügen
      for (let index = 0; index < this.phonebook.length; index++) {
        let e = this.phonebook[index];
        string += index + 1 + ";\"" + e.displayName + "\";" + e.phonenumber + ";40;;;;-1;0\r\n";
      }

      // Blob erstellen (UTF-8 bleibt, BOM stellt sicher, dass Programme es erkennen)
      const csvBlob = new Blob([string], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(csvBlob);
      link.download = 'phonebook_lardis.csv';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    download_easybell(){
      let string = "\"First Name\";\"Last Name\";Company\r\n"
      for(let index = 0; index < this.phonebook.length; index++){
        let e = this.phonebook[index]
        string += e.displayName + ";;;phoneType;" + e.phonenumber + ";phone\r\n"
      }
      const csvBlob = new Blob([string], { type: 'text/csv;charset=utf-8;' });
      // Download-Link erstellen
      const link = document.createElement('a');
      link.href = URL.createObjectURL(csvBlob);
      link.download = 'phonebook_easybell.csv';
      document.body.appendChild(link);

      // Klick simulieren und Link entfernen
      link.click();
      document.body.removeChild(link);
    },
    call_entry(item){
      window.open('tel:' + item.phonenumber)
    },
    delete_entry(item){
      this.$store.state.general.dialogs.push({title: 'Eintrag löschen', text: 'Du bist dabei, den Eintrag ' + item.displayName +' zu löschen. Bist du dir sicher?',  btn_1_title: 'Abbrechen', btn_2_title: 'Löschen', btn_2_update: { "payload_type": 'DELETE', "context": "/phonebook/" + item.id}, btn_2_color: 'error', show: true})
    },
    set_entry(id, display_name, phonenumber){
      this.$store.dispatch("update", { "payload_type": 'POST', "context": "/phonebook", 'payload': { id: id, displayName: display_name, phonenumber: phonenumber} })
    },
  },
  computed: {
    new_contact_is_valid(){
      return this.new_contact.display_name && this.new_contact.phonenumber
    },
    phonebook(){
      return this.$store.state.phonebook.book === null ? [] : this.$store.state.phonebook.book
    }
  }
};
</script>

<style scoped>

</style>
